/** @enum {number} */
const StorageType = Object.freeze({
    LOCAL_STORAGE: 0,
    SESSION_STORAGE: 1,
    // Useful for testing
    NODE_LOCAL_STORAGE: 2
})

export default StorageType;